const totalScore = (pages, answers) => {
	let totalScore = 0;

	for (let questionIndex = 0; questionIndex < answers.length; questionIndex++) {
		const page = pages[questionIndex];
		const answer = answers[questionIndex];
		const score = parseInt(page.answers[answer].scoring_value);

		totalScore += score;
	}

	return totalScore;
};

const spotDepression = (answers) => {
	const secondAnswer = answers[1] || 0;
	const eigthAnswer = answers[7] || 0;

	// if 2nd or 8th answer is 3+, this will be 3+ too
	const largestAnswer = Math.max(secondAnswer, eigthAnswer);
	return largestAnswer >= 3;
}

const scoringRules = {
	Consumer: (pages, answers) => {
		const total = totalScore(pages, answers);

		// If total score < 1 then response = low risk
		// If total score ≥ 1 and ≤ 29 the response = medium risk
		// If total score ≥ 30 the response = high risk
		if (total < 1) {
			return { rating: 'Low' };
		} else if (total >= 1 && total < 30) {
			return { rating: 'Medium' };
		} else {
			return { rating: 'High' };
		}
	},

	Carer: (pages, answers) => {
		const depressed = spotDepression(answers);
		const total = totalScore(pages, answers);

		// If total score < 1 then response = Low risk
		// If total score ≥ 1and ≤ 19 then response = medium risk
		// If total score ≥ 20 then response = high risk
		if (total < 1) {
			return { rating: 'Low', depressed };
		} else if (total >= 1 && total < 20) {
			return { rating: 'Medium', depressed };
		} else {
			return { rating: 'High', depressed };
		}
	},
};

module.exports = {
	gradeScreener: ({ type, pages, answers }) => scoringRules[type](pages, answers),
};



// WEBPACK FOOTER //
// ./src/managers/screenerManager.js